import React, { useEffect, useState, useMemo, useReducer } from "react";
import LoadingIcon from "./Components/LoadingSpinner";
import AppSDK from "@growthos/ui-app-sdk";
import { AnalyticsProvider } from "@growthos/ui-analytics";
import { addAllAarcValues, fetchCurrencySymbols, fetchSyncStatuses, storeContextData } from "./Flux/Actions/BookFilterActions";
import { fetchUserRole } from "./Flux/Actions/PermissionsActions";
import NavigationWrapper from "./Components/NavigationWrapper/NavigationWrapper";

import "./app.scss";

const APP_CODE = process.env.REACT_APP_PM_APP_CODE;
// TODO: add api key to higher environments, switch over to this variable
// const PENDO_API_KEY = process.env.REACT_APP_PENDO_API_KEY;
const PENDO_API_KEY = "93b796da-0cfd-482e-4a5a-20511c9ec7a4";

const App = () => {
	const [stateIsReady, setStateIsReady] = useState(AppSDK.getIsReady());

	useEffect(() => {
		AppSDK.onReady(({ contextId, context }) => {
			storeContextData(contextId, context);
			setStateIsReady(true);
		});
		AppSDK.initialize({ appCode: APP_CODE });

		return () => {
			setStateIsReady(false);
		};
	}, []);

	useEffect(() => {
		if (stateIsReady === true) {
			addAllAarcValues();
			fetchCurrencySymbols();
			fetchUserRole(AppSDK.getContextId());
			fetchSyncStatuses();
		}
	}, [stateIsReady]);

	const { user, contextId, context, briefId, currentApp } = useMemo(
		() => ({
			user: AppSDK.ApiUser.getUser(),
			contextId: AppSDK.getContextId(),
			context: AppSDK.getContext(),
			briefId: AppSDK.getBriefId(),
			currentApp: AppSDK.getCurrentApp()
		}),
		[stateIsReady]
	);

	return (
		<>
			{stateIsReady ? (
				<AnalyticsProvider pendoApiKey={PENDO_API_KEY} contextId={contextId} context={context} briefId={briefId} currentApp={currentApp} user={user}>
					<NavigationWrapper />
				</AnalyticsProvider>
			) : (
				<LoadingIcon />
			)}
		</>
	);
};

export default App;
